<template>
  <div class="card-wrapper" :class="{ 'has-border': isOrderDetail }">
    <div>
      <h5 :class="{ 'is-details': isOrderDetail }">Card Message</h5>
      <router-link
        tag="button"
        :to="{ name: 'CardMessage', query: { editing: 1 } }"
        class="whitebutton-gemnote whitebutton-gemnote--tiny"
        v-if="showEditButtons"
        >Edit</router-link
      >
    </div>
    <div v-if="cardMessage" class="card-description-wrapper">
      <p v-for="(message, key) in renderCardMessage" :key="key">
        {{ message }}
      </p>
    </div>
    <div v-else>
      <p class="no-message">
        There was no message included for this order.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardMessage',
  props: {
    cardMessage: {
      type: String
    },
    showEditButtons: {
      type: Boolean,
      default: false
    },
    isOrderDetail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderCardMessage() {
      return this.cardMessage.split('\n').filter(line => !!line.trim())
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.card-description-wrapper {
  display: flex !important;
  justify-content: left !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}

.card-wrapper {
  width: 100%;
  height: 100%;
  padding: 1.75rem;
  background: $dark-gray;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h5 {
      font-family: $inter;
      font-size: 0.875rem;
      text-align: left;
      font-weight: bold;

      &.is-details {
        font-family: Inter;
        font-size: 14px;
        font-weight: 700;
      }
    }

    margin-bottom: 1.5rem;
  }

  p {
    font-family: $inter;
    text-align: left;
    font-size: 0.813rem;
    line-height: 23px;
  }

  .no-message {
    font-family: $inter;
    text-align: justify;
    font-size: 16px;
    opacity: 0.5;
  }
}

.whitebutton-gemnote--tiny {
  width: 76px;
  height: 30px;
  font-size: 0.875rem;
  font-weight: 400;
}
</style>
